<template>
  <div class="md-layout-item">
    <isis-tabs
      @on-tab-change="onTabChanged"
      :tab-active="tabActive"
      class="tabs-student-info"
    >
      <template #content>
        <md-tab
          :id="tabs.personalInfo"
          md-label="student.personal_information"
          class="px-1"
        >
          <personal-information
            :ref="tabs.personalInfo"
            :path="path"
            :isEdit="true"
            :serverValidations="serverValidations"
          ></personal-information>
        </md-tab>

        <md-tab :id="tabs.gradebook" md-label="student.gradebook" class="px-1">
          <gradebook
            :isActiveTab="currentTabId === tabs.gradebook"
            :ref="tabs.gradebook"
          ></gradebook>
        </md-tab>

        <md-tab
          :id="tabs.creditSummary"
          md-label="student.credit_summary"
          class="px-1"
        >
          <credit-summary
            :isActiveTab="currentTabId === tabs.creditSummary"
            :ref="tabs.creditSummary"
            :studentData="studentData"
          ></credit-summary>
        </md-tab>

        <md-tab :id="tabs.class" md-label="student.class" class="px-1">
          <class
            :isActiveTab="currentTabId === tabs.class"
            :studentData="studentData"
            :ref="tabs.class"
            @reloadData="reloadClassData"
          ></class>
        </md-tab>

        <md-tab
          :id="tabs.assessment"
          md-label="student.assessment"
          class="px-1"
        >
          <assessment
            :student-data="studentData"
            :ref="tabs.assessment"
          ></assessment>
        </md-tab>

        <md-tab
          :id="tabs.attendance"
          md-label="student.attendance"
          class="px-1"
        >
          <attendance
            :isActiveTab="currentTabId === tabs.attendance"
            :ref="tabs.attendance"
            :student-data="studentData"
          ></attendance>
        </md-tab>

        <md-tab :id="tabs.schedule" md-label="common.schedule" class="px-1">
          <tab-schedule
            :isActiveTab="currentTabId === tabs.schedule"
            :ref="tabs.schedule"
          ></tab-schedule>
        </md-tab>

        <md-tab :id="tabs.restrict" md-label="student.more" class="px-1">
          <restrict :ref="tabs.restrict"></restrict>
        </md-tab>

        <md-tab
          :id="tabs.communicationLog"
          v-if="isListCommunicationLog"
          md-label="student.communication_log"
          class="px-1"
        >
          <communication-log
            :isActiveTab="currentTabId === tabs.communicationLog"
            :is-tab-communication-log="currentTabId === tabs.communicationLog"
            @edit-communication="editCommunication"
            :ref="tabs.communicationLog"
            @update="refetchDataCommunication()"
          ></communication-log>
        </md-tab>
        <md-tab :id="tabs.behavior" md-label="class.behavior" class="px-1">
          <Behavior
            :isActiveTab="currentTabId === tabs.behavior"
            @addBehavior="addBehavior"
            @viewBehavior="viewBehavior"
            :ref="tabs.behavior"
          ></Behavior>
        </md-tab>
        <md-tab
          :id="tabs.enrollment"
          md-label="student.history_enrollment"
          class="px-1"
        >
          <enrollment
            :isActiveTab="currentTabId === tabs.enrollment"
            :student-data="studentData"
            :ref="tabs.enrollment"
            @edit-enrollment="editEnrollment"
            @add-enrollment="addEnrollment"
          ></enrollment>
        </md-tab>
        <md-tab
          :id="tabs.progressReport"
          md-label="class.progress_report"
          class="px-1"
        >
          <ProgressReport
            :isActiveTab="currentTabId === tabs.progressReport"
            :ref="tabs.progressReport"
          ></ProgressReport>
        </md-tab>
        <md-tab
          v-if="studentData && studentData.is_high_school_program"
          :id="tabs.graduation"
          md-label="student.graduation"
          class="px-1"
        >
          <graduation
            :isActiveTab="currentTabId === tabs.graduation"
            :ref="tabs.graduation"
          ></graduation>
        </md-tab>
      </template>
    </isis-tabs>
    <!--    modal detail communication log-->
    <common-modal
      width="80%"
      height="auto"
      :name="communicationModalName"
      :hideFooter="true"
      :hideHeader="true"
      :showBtnEdit="true"
      v-if="dataEditCommunication"
    >
      <template #modal-body>
        <communication-log-form
          :data="dataEditCommunication"
          :isEditModal="isEditCommunicationModal"
          :modalName="communicationModalName"
          @refetchTableData="refetchDataCommunication"
        ></communication-log-form>
      </template>
    </common-modal>
    <!--    modal communication log detail-->

    <!--    modal add enrollment-->
    <common-modal
      width="80%"
      height="auto"
      :name="addEnrollmentModalName"
      :title="$t('student.enrollment')"
      :hideFooter="true"
      :showBtnEdit="true"
    >
      <template #modal-body>
        <add-enrollment
          @rerenderTable="reloadComponent"
          :add-enrollment-modal-name="addEnrollmentModalName"
        ></add-enrollment>
      </template>
    </common-modal>
    <!--    modal add enrollment-->

    <!--    modal enrollment detail -->
    <common-modal
      v-if="studentData"
      width="80%"
      height="auto"
      :name="editEnrollmentModalName"
      :hideFooter="true"
      :title="$t('student.enrollment') + ': ' + studentData.full_name"
      :showBtnEdit="true"
    >
      <template #modal-body>
        <enrollment-detail
          v-if="dataDetailEnrollment"
          ref="refEnrollmentDetail"
          :data-detail="dataDetailEnrollment"
          @editingEnrollment="reloadComponent"
        ></enrollment-detail>
      </template>
    </common-modal>

    <!--    modal enrollment detail -->

    <!--    modal add behavior -->
    <common-modal
      width="80%"
      height="auto"
      name="BehaviorForm"
      :hideFooter="true"
      :hideHeader="true"
    >
      <template #modal-body>
        <BehaviorForm
          v-if="studentData"
          :mode="behaviorData.mode"
          :behaviorData="behaviorData.data"
          :student="studentData"
          modalName="BehaviorForm"
          ref="BehaviorForm"
          @reloadData="reloadBehavior"
        ></BehaviorForm>
      </template>
    </common-modal>
    <!--    modal add behavior  -->

    <contact-modal
      v-if="studentData"
      :student-data="studentData"
      :name="contactModalName"
      ref="contactModal"
    ></contact-modal>
  </div>
</template>

<script>
import IsisTabs from "@/components/Base/IsisTabs";
import PersonalInformation from "./PersonalInformation";
import Gradebook from "./Gradebook";
import CreditSummary from "./Credit";
import Restrict from "./Restrict";
import ContactModal from "../Family/ContactModal";
import { genErrMsgOj } from "@/helpers/utils";
import Class from "./Class";
import { All, Student } from "@/constants/Permissions";
import Behavior from "./Behavior";
import CommunicationLog from "./CommunicationLog";
import CommunicationLogForm from "./CommunicationLog/CommunicationLogFormEdit";
import CommonModal from "@/components/Base/CommonModal";
import cloneDeep from "lodash/cloneDeep";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
import { mapGetters, mapState } from "vuex";
import Assessment from "./Assessment";
import Attendance from "./Attendance";
import Graduation from "./Graduation";
import TabSchedule from "./Schedule";
import Enrollment from "./Enrollment";
import EnrollmentDetail from "./Enrollment/EditEnrollment";
import BehaviorForm from "./Behavior/BehaviorForm";
import AddEnrollment from "./Enrollment/AddEnrollment";
import ProgressReport from "./ProgressReport";

export default {
  name: "student-information-tabs",
  components: {
    AddEnrollment,
    TabSchedule,
    Attendance,
    Assessment,
    Class,
    IsisTabs,
    PersonalInformation,
    Restrict,
    Gradebook,
    CreditSummary,
    ContactModal,
    CommunicationLog,
    CommonModal,
    CommunicationLogForm,
    Graduation,
    Enrollment,
    EnrollmentDetail,
    Behavior,
    BehaviorForm,
    ProgressReport
  },
  data() {
    return {
      tabs: {
        personalInfo: "tab-personal-info",
        gradebook: "tab-grade-book",
        creditSummary: "tab-credit-summary",
        class: "tab-class",
        assessment: "tab-assessment",
        attendance: "tab-attendance",
        restrict: "tab-restrict",
        schedule: "tab-schedule",
        communicationLog: "tab-communication-log",
        behavior: "tab-behavior",
        graduation: "tab-graduation",
        enrollment: "tab-enrollment",
        progressReport: "progress-report"
      },
      tabsWithoutFooter: [
        "tab-grade-book",
        "tab-credit-summary",
        "tab-class",
        "tab-communication-log",
        "tab-behavior",
        "tab-assessment",
        "tab-attendance",
        "tab-schedule",
        "tab-schedule",
        "tab-enrollment",
        "tab-graduation",
        "progress-report"
      ],
      curTab: null,
      currentTabId: "",
      studentData: null,
      contactModalName: "contact-modal",
      serverValidations: {},
      dataEditCommunication: null,
      isEditCommunicationModal: false,
      communicationModalName: "communication-log",
      dataDetailEnrollment: null,
      behaviorData: { data: "", mode: "add" },
      hasValidRole,
      tabActive: null,
      fetchDataEnrollment: null,
      addEnrollmentModalName: "add-enrollment",
      editEnrollmentModalName: "enrollment-detail"
    };
  },
  props: ["path"],
  inject: ["updateStudentData"],
  computed: {
    ...mapState("user", ["info"]),
    ...mapGetters("user", ["role"]),
    isListCommunicationLog() {
      return this.$can(Student.actions.viewCommunicationLog, Student.subject);
    }
  },
  created() {
    this.setStatusActiveCommunicationLog();
  },
  methods: {
    reloadClassData() {
      this.$refs[this.tabs.class].fetchDataClass();
    },
    reloadComponent() {
      this.$refs["tab-enrollment"].fetchEnrollment();
    },
    addEnrollment() {
      this.$modal.show(this.addEnrollmentModalName);
    },
    editEnrollment(value) {
      this.dataDetailEnrollment = value;
      this.$modal.show(this.editEnrollmentModalName);
    },
    addBehavior() {
      this.behaviorData.data = {};
      this.behaviorData.mode = "add";
      this.$modal.show("BehaviorForm");
    },
    viewBehavior(behavior) {
      this.behaviorData.data = behavior;
      this.behaviorData.mode = "view";
      this.$modal.show("BehaviorForm");
    },
    reloadBehavior() {
      this.$refs["tab-behavior"].fetchBehavior();
    },
    setStatusActiveCommunicationLog() {
      const query = this.$route.query;
      if (query.isActiveTabCommunicationLog) {
        this.tabActive = this.tabs.communicationLog;
        this.$router.replace({ query: {} });
      }
    },
    editCommunication(value) {
      this.dataEditCommunication = cloneDeep(value);
      this.isEditCommunicationModal = false;
      this.$nextTick(() => {
        this.$modal.show(this.communicationModalName);
      });
    },
    refetchDataCommunication() {
      this.$refs[this.tabs.communicationLog].getTableData();
      this.$modal.hide(this.communicationModalName);
    },

    onSelect: function(items) {
      this.selected = items;
    },

    onTabChanged(tabId) {
      this.currentTabId = tabId;
      const hasFooterActions = !this.tabsWithoutFooter.includes(tabId);
      this.curTab = this.$refs[tabId];
      this.$emit("update-check-footer", hasFooterActions);
    },

    getFormData() {
      if (!this.curTab) {
        console.log("Not form data!");
        return;
      }

      return this.curTab.getFormData();
    },

    setFormData(data) {
      this.studentData = Object.assign({}, this.studentData, data);
      Object.values(this.tabs)
        .filter(
          tabId =>
            tabId !== this.tabs.communicationLog &&
            tabId !== this.tabs.graduation
        )
        .forEach(tabId => {
          this.$refs[tabId].loadData && this.$refs[tabId].loadData(data);
        });
    },
    showContactModal(data) {
      this.$refs.contactModal.show(data);
    },

    async updateAccount() {
      // if tab has it's func
      if (this.curTab.updateAccount) {
        return this.curTab.updateAccount();
      }

      // default;
      try {
        const formData = await this.curTab.getFormData();
        await this.updateStudentData(formData);
      } catch (error) {
        const errData = error.response?.data;
        if (errData) this.serverValidations = genErrMsgOj(errData.messages);
      }
    }
  },
  mounted() {
    this.onTabChanged(this.tabs.personalInfo);
    if (!this.$can(All.actions, All.subject)) {
      this.tabsWithoutFooter.push("tab-restrict");
    }
    if (hasValidRole(this.role, [Role.Student])) {
      this.tabsWithoutFooter.push("tab-personal-info");
    }
  },
  provide() {
    return {
      showContactModal: this.showContactModal,
      generatePdfAutoTable: this.generatePdfAutoTable
    };
  }
};
</script>

<style lang="scss">
.tabs-student-info .md-tabs-navigation {
  flex-wrap: wrap;
}
</style>
